import { Stack, UseDisclosureProps, VStack } from '@chakra-ui/react';

import { FC } from 'react';
import { Modal } from '../modal';
import { SocialShare } from '../social-share';
import { CopyLink } from '../copy-link';
import { useIsMobile } from '../../hooks';

export interface ShareFundraiserProps
  extends Required<Pick<UseDisclosureProps, 'isOpen' | 'onClose'>> {
  trackingLabel?: string;
  personalPageUrl?: string;
}

export const ShareFundraiser: FC<ShareFundraiserProps> = ({
  isOpen,
  onClose,
  trackingLabel,
  personalPageUrl,
}) => {
  const isMobileBreakpoint = useIsMobile();
  const pageUrl = personalPageUrl || '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Share your Fundraiser"
      size={isMobileBreakpoint ? 'xs' : '2xl'}
    >
      <VStack spacing={4} align="stretch">
        <SocialShare url={pageUrl} trackingLabel={trackingLabel} />

        <Stack spacing={4} w="full" direction={['column', 'column', 'row']}>
          <CopyLink
            url={pageUrl}
            copyText="Your fundraising page URL"
            copyLinkText="Copy Link"
            trackingLabel={trackingLabel}
          />
        </Stack>
      </VStack>
    </Modal>
  );
};
